"use client";

import React, { useState } from "react";
import RTE from "./RTE";

const TourAvailabilityOthers: React.FC = () => {
  // Information of Availabilities
  const [tourPackage, setTourPackage] = useState("");
  const [availableFrom, setAvailableFrom] = useState("");
  const [expiryDate, setExpiryDate] = useState("");

  // Other Information
  const [googleMap, setGoogleMap] = useState("");
  const [tourHighlights, setTourHighlights] = useState("");
  const [availableCountry, setAvailableCountry] = useState("");
  const [availableCity, setAvailableCity] = useState("");
  const [paymentStructure, setPaymentStructure] = useState("");
  const [content, setContent] = useState("");

  // Documentation
  const [documentation, setDocumentation] = useState("");
  const [documentationContent, setDocumentationContent] = useState("");

  // Cancellation Policy
  const [cancellationPolicy, setCancellationPolicy] = useState("");
  const [cancellationContent, setCancellationContent] = useState("");

  // Refund Policy
  const [refundPolicy, setRefundPolicy] = useState("");
  const [refundContent, setRefundContent] = useState("");

  // Term Policy
  const [termPolicy, setTermPolicy] = useState("");
  const [termContent, setTermContent] = useState("");

  return (
    <div className="space-y-6">
      {/* Information of Availabilities */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h2 className="text-sm font-semibold text-gray-800 mb-4">
          Information of Availabilities
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-xs">
          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Tour Package *
            </label>
            <select
              value={tourPackage}
              onChange={(e) => setTourPackage(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              <option>--Select Tours--</option>
            </select>
          </div>

          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Tours Package Available From *
            </label>
            <input
              type="date"
              value={availableFrom}
              onChange={(e) => setAvailableFrom(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>

          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Tours Package Expiry Date *
            </label>
            <input
              type="date"
              value={expiryDate}
              onChange={(e) => setExpiryDate(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* Other Information */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h2 className="text-sm font-semibold text-gray-800 mb-4">
          Other Information
        </h2>
        <div className="space-y-4 text-xs">
          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Google Map *
            </label>
            <RTE
              content={googleMap}
              onChange={setGoogleMap}
            />
          </div>

          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Tour Highlights *
            </label>
            <RTE
              content={tourHighlights}
              onChange={setTourHighlights}
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div>
              <label className="block text-[11px] font-medium text-gray-700 mb-1">
                Available Country *
              </label>
              <select
                value={availableCountry}
                onChange={(e) => setAvailableCountry(e.target.value)}
                className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
              >
                <option>--Select Country--</option>
              </select>
            </div>

            <div>
              <label className="block text-[11px] font-medium text-gray-700 mb-1">
                Available City *
              </label>
              <input
                type="text"
                value={availableCity}
                onChange={(e) => setAvailableCity(e.target.value)}
                className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-[11px] font-medium text-gray-700 mb-1">
                Payment Structure *
              </label>
              <select
                value={paymentStructure}
                onChange={(e) => setPaymentStructure(e.target.value)}
                className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
              >
                <option>--Payment Structure--</option>
              </select>
            </div>
          </div>

          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Content *
            </label>
            <RTE
              content={content}
              onChange={setContent}
            />
          </div>
        </div>
      </div>

      {/* Documentation */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h2 className="text-sm font-semibold text-gray-800 mb-4">
          Documentation
        </h2>
        <div className="space-y-4 text-xs">
          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Documentation *
            </label>
            <select
              value={documentation}
              onChange={(e) => setDocumentation(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              <option>--Documentation--</option>
            </select>
          </div>

          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Content *
            </label>
            <RTE
              content={documentationContent}
              onChange={setDocumentationContent}
            />
          </div>
        </div>
      </div>

      {/* Cancellation Policy */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h2 className="text-sm font-semibold text-gray-800 mb-4">
          Cancellation Policy
        </h2>
        <div className="space-y-4 text-xs">
          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Cancellation Policy *
            </label>
            <select
              value={cancellationPolicy}
              onChange={(e) => setCancellationPolicy(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              <option>--Cancellation Policy--</option>
            </select>
          </div>

          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Content *
            </label>
            <RTE
              content={cancellationContent}
              onChange={setCancellationContent}
            />
          </div>
        </div>
      </div>

      {/* Refund Policy */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h2 className="text-sm font-semibold text-gray-800 mb-4">
          Refund Policy
        </h2>
        <div className="space-y-4 text-xs">
          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Refund Policy *
            </label>
            <select
              value={refundPolicy}
              onChange={(e) => setRefundPolicy(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              <option>--Refund Policy--</option>
            </select>
          </div>

          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Content *
            </label>
            <RTE
              content={refundContent}
              onChange={setRefundContent}
            />
          </div>
        </div>
      </div>

      {/* Term Policy */}
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h2 className="text-sm font-semibold text-gray-800 mb-4">
          Term Policy
        </h2>
        <div className="space-y-4 text-xs">
          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Term Policy *
            </label>
            <select
              value={termPolicy}
              onChange={(e) => setTermPolicy(e.target.value)}
              className="w-full border border-gray-300 rounded px-2 py-1.5 text-xs focus:outline-none focus:ring-1 focus:ring-blue-500"
            >
              <option>--Term Policy--</option>
            </select>
          </div>

          <div>
            <label className="block text-[11px] font-medium text-gray-700 mb-1">
              Content *
            </label>
            <RTE
              content={termContent}
              onChange={setTermContent}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TourAvailabilityOthers;

